/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import StringResources from 'nls/StringResources';
import { DropDownToolbarItem } from 'components/toolbar/items';
import AddNewCard from './AddNewCard';
import AddIcon from '@ba/ba-graphics/dist/icons-js/add_32';

import './AddNewCard.scss';

class AddNewCardToolbarItem extends Component {

	constructor(props) {
		super(props);

		this.state = {
			open: false
		};
	}

	render() {
		return (
			<DropDownToolbarItem
				selected={this.state.open}
				label={StringResources.get('exploreToolbar_new')}
				title={StringResources.get('exploreToolbar_new')}
				onPrimaryAction={() => this.onPrimaryAction()}
				onClickOutside={() => this.onClickOutside()}
				data-usage={'newCard'}
				excludeCaretIcon={true}
				kind={'ghost'}
				id='addNewCard'
				iconId={AddIcon.id}
			>
				<AddNewCard
					onClick={(...params) => this.onAddCard(...params)}
					excluded={this.getExcludedTypes()}
				/>
			</DropDownToolbarItem>
		);
	}

	onPrimaryAction() {
		// Toggle the dropdown.
		this.setState({
			open: !this.state.open
		});
	}

	onClickOutside() {
		// Close the dropdown.
		this.setState({
			open: false
		});
	}

	onAddCard(event) {
		// Close the dropdown.
		this.setState({
			open: false
		});

		this.props.onAddCard(event);
	}

	getExcludedTypes() {
		const excluded = [];
		if (this.props.exploreVM.isStartingPointsDisplayed()) {
			excluded.push('startingPoints');
		}

		return excluded;
	}

}

AddNewCardToolbarItem.propTypes = {
	onAddCard: PropTypes.func,
	exploreVM: PropTypes.object
};

AddNewCardToolbarItem.defaultProps = {
	onAddCard: () => {}
};

export default AddNewCardToolbarItem;



// WEBPACK FOOTER //
// ./src/js/components/cards/AddNewCardToolbarItem.js